import { getApiErrorMessage } from "./apiError";
import { apiFetch } from "./apiFetch";

const API_URL = process.env.REACT_APP_API_URL;

export type VatRowDTO = {
  VATPercent: number | string;
  VATBaseAmount: number;
  VATAmount: number;
};

export async function getDocumentVat(
  companyId: string,
  documentId: string
) {
  const res = await apiFetch(
    `${API_URL}/documents/${documentId}/vat?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać danych VAT.")
    );
  }

  return res.json() as Promise<VatRowDTO[]>;
}
